import { combineReducers } from 'redux';
import signIn from '../components/SignInForm/reducer';
import authModal from '../components/AuthModal/reducers';
import modalContainer from '../components/ModalContainer/reducers';
import fullRegistration from '../components/FullRegistration/reducers';
import passwordResetSuccessModal from '../components/PasswordResetSuccessModal/reducers';
import { sideMenu } from 'shared/components/UserMenu/reducer';

export default combineReducers({
  signIn,
  authModal,
  modalContainer,
  fullRegistration,
  passwordResetSuccessModal,
  sideMenu,
});
